/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Tab_SubscriptionsInputs */

const en_my_payments_tab_subscriptions = /** @type {(inputs: My_Payments_Tab_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

const pl_my_payments_tab_subscriptions = /** @type {(inputs: My_Payments_Tab_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcje`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {My_Payments_Tab_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_tab_subscriptions = /** @type {((inputs?: My_Payments_Tab_SubscriptionsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Tab_SubscriptionsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_tab_subscriptions(inputs)
	return en_my_payments_tab_subscriptions(inputs)
});